import React from 'react'
import TOCSection from '../components/TOCSection'
import CSS from './MainNavigation.module.scss'

/**
 * MainNavigation
 */

const MainNavigation = () => {
  return (
    <div className={CSS.root}>
      {/* Placeholder for menu */}
      <div className={CSS.head} />

      {/* TOC sidebar */}
      <div className={CSS.body}>
        <TOCSection />
      </div>
    </div>
  )
}

export default MainNavigation
